'use client';

import { useFiltersContext } from '@components/FilterPage/Context/useFiltersContext';
import { Box, freddyTheme, ListItem, Typography } from '@coolblue-development/freddy';
import deselectFilterTrigger from '@coolblue-development/ga4-events/triggers/RecruitmentFilter/deselectFilterTrigger';
import { Cross } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { FilterCategories } from '@server/careers-backend/search';

type Props = {
  filterKey: FilterCategories;
  label: string;
  filterValues: string;
};

export const SelectedRow = ({ filterKey, label, filterValues }: Props) => {
  const { setFilter } = useFiltersContext();
  const { trackEvent } = useAnalytics();

  const trackParams = {
    sub_feature: 'filter_list' as const,
    filter_name: filterKey,
    filter_value: filterValues,
    number_of_items: filterValues.split(',').length,
    is_recommended: true
  };

  return (
    <ListItem sx={{ display: 'flex !important', alignItems: 'center' }}>
      <Typography mb={0} component='span' sx={{ flexGrow: 1 }}>
        {label}: <Typography component='strong'>{filterValues}</Typography>
      </Typography>
      <Box
        component='button'
        sx={{
          display: 'flex !important',
          all: 'unset',
          paddingLeft: freddyTheme.spacing[300],
          '&:hover': { cursor: 'pointer' }
        }}
        aria-label={`Remove filter ${label}`}
        onClick={() => {
          trackEvent(deselectFilterTrigger(trackParams));
          setFilter(filterKey, []);
        }}
      >
        <Cross color={freddyTheme.color.icon.interactiveSubtle} size='small' />
      </Box>
    </ListItem>
  );
};
